import React from "react"

import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Box, Grid, Container, Typography } from "@material-ui/core"
import "../styles/global.css"
import AppNavBar from "../components/app-bar"
import Timer from "../components/timer"
import EmailComponent from "../components/email-component"

const IndexPage = function () {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up("sm"))
  return (
    <Layout>
      <SEO title="Darasa" />
      <AppNavBar />
      <Container>
        <Grid container style={{ height: "70vh", marginTop: "80px" }}>
          <Grid item xs={12} md={7} alignItems="center" mt={5}>
            <Box mt={8} color="purple">
              <Typography
                align="start"
                variant="h4"
                style={{ fontWeight: "bold" }}
              >
                STAY TUNED WE'RE
              </Typography>
            </Box>

            <Box ml={5} color="purple">
              <Typography variant="h4" style={{ fontWeight: "bold" }}>
                COMING SOON
              </Typography>
            </Box>
            <Box>
              <Timer />
            </Box>
            <Box mt={3}>
              <Typography
                align="start"
                style={{ color: "#EC7623" }}
                variant="h4"
              >
                Be the first to know
              </Typography>
            </Box>
            <Box mt={2}>
              <EmailComponent />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  )
}

export default IndexPage
